export const CONFIG_LOAD = 'CONFIG_LOAD';
export const CONFIG_LOADED = 'CONFIG_LOADED';
